import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { VoyageDetailsModel } from 'src/app/models/VoyageDetailsModel';
import { BookingService } from '../../landing/services/booking.service';

@Component({
  selector: 'app-voyage-detail',
  templateUrl: './voyage-detail.component.html',
  styleUrls: ['./voyage-detail.component.scss']
})
export class VoyageDetailComponent implements OnInit {

  stateParams: any;
  // currentPage: number = 1;
  // pageSize: number = 10;
  totalCount: number = 0;
  voyageDetails: any;
  fromTranshipmentSchedule: any;
  toTranshipmentSchedule: any;
  cubicmeter:number;
  companyLogo: string;
  companyName: string;
  toCompanyLogo: string;
  toCompanyName: string;
  fromVesselName:string;
  toVesselName:string;
  selected: any;
  constructor(private activatedRoute: ActivatedRoute, private router: Router, private toastr: ToastrService,
    private spinner: NgxSpinnerService, private bookingService: BookingService) {
    this.activatedRoute.paramMap.subscribe((params: any) => {
      this.stateParams = params.params;
      
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    });
  }

  ngOnInit() {
    this.getVoyageDetailsByVesselsId();

  }

  getVoyageDetailsByVesselsId() {
    if (this.stateParams != null && this.stateParams != undefined) {
      var idVm = new VoyageDetailsModel();
      idVm.vesselsId = this.stateParams.id > 0 ? parseInt(this.stateParams.id) : 0;
      idVm.fromPortId = this.stateParams.fromPortId > 0 ? parseInt(this.stateParams.fromPortId) : 0;
      idVm.toPortId = this.stateParams.toPortId > 0 ? parseInt(this.stateParams.toPortId) : 0;
      idVm.searchDate = this.stateParams.fromDate;
      // idVm.cubicMeter=this.stateParams.cubicMeter > 0 ? parseFloat(this.stateParams.cubicMeter):0;
      idVm.toPortArrivalDate = this.stateParams.toDate;
      idVm.toVesselsId = this.stateParams.toVesselsId > 0 ? parseInt(this.stateParams.toVesselsId) : 0;
      idVm.midPortId = this.stateParams.midPortId > 0 ? parseInt(this.stateParams.midPortId) : 0;
      idVm.transhipment = this.stateParams.trashipment > 0 ? parseInt(this.stateParams.trashipment) : 0;
      idVm.fromShippingLineId = this.stateParams.shippingId > 0 ? parseInt(this.stateParams.shippingId) : 0;
      idVm.toShippingLineId = this.stateParams.toShippingId > 0 ? parseInt(this.stateParams.toShippingId) : 0;
      idVm.findToDate = this.stateParams.findToDate;
      this.spinner.show();
      this.bookingService.getVoyageDetailsByVesselsId(idVm).subscribe((response: any) => {
        if (response != null && response.content != null && response.content.voyageData.length > 0) {
          this.totalCount = response.content.voyageData.length;
          this.voyageDetails = response.content.voyageData;
          
          this.cubicmeter=response.content.voyageData[0].cubicMeter;
          this.companyLogo = response.content.voyageData[0].companyLogo;
          this.companyName = response.content.voyageData[0].companyName;

          this.fromVesselName = response.content.voyageData[0].vesselsName;
          this.toVesselName = response.content.voyageData[0].toVesselsName;
          this.fromTranshipmentSchedule = response.content.fromTranshipmentSchedule;

          if(this.stateParams != null && this.stateParams.trashipment == 1)
          {
            this.toCompanyLogo = response.content.voyageData[0].toCompanyLogo;
            this.toCompanyName = response.content.voyageData[0].toCompanyName;
            this.toTranshipmentSchedule = response.content.toTranshipmentSchedule;
          }
          this.spinner.hide();          
        }
        else {
          this.spinner.hide();
          this.toastr.error(response.message, 'Error');
        }
      },
        (error: any) => {
          this.spinner.hide();
         
          this.toastr.error(error.error.title, 'Error');
        }
      );
    }
  }

  bookingRequest() {
    var vales = this.selected;
    var transimentflag = 0;
    if(this.stateParams.trashipment == 1)
    {
     transimentflag = 1;
    }
    if (this.selected != undefined && this.selected != null && this.selected != '') {
      var selectedData = this.voyageDetails.filter(x => x.id == this.selected);
      if (selectedData != null && selectedData.length > 0) {
        var url = '/' + 'bookingdetail' + '/' + selectedData[0].id + '/' + selectedData[0].vesselsId + '/' + selectedData[0].fromPortId + '/' + selectedData[0].toPortId + '/' + selectedData[0].fromPortCountryId + '/' + selectedData[0].toPortCountryId +
          '/' + selectedData[0].shippingLineId  + '/'  +  '/ '  + transimentflag;
        this.router.navigate([url]);
      }
    }
    else {
      this.toastr.error('Please select Voyage', 'Error');
    }
  }

  // paginate(event) {
  //   this.currentPage = event.page + 1;
  //   this.getVoyageDetailsByVesselsId();
  // }

}
